import React from "react";
import { Marker, Popup } from "react-leaflet";
import { divIcon } from "leaflet";

import "./style.css";

export const MapMarker = ({ marker, draggable, withPopup }) => (
  <Marker
    {...{
      icon: divIcon({
        html: `<div class="marker">
        <svg width="25px" height="41px" viewBox="0 0 48 72" fill="${marker.color}">
          <path d="M24,0 C11.406,0 0,10.209 0,22.806 C0,35.4 10.407,50.436 24,72 C37.593,50.436 48,35.4 48,22.806 C48,10.209 36.597,0 24,0 L24,0 Z M24,33 C19.029,33 15,28.971 15,24 C15,19.029 19.029,15 24,15 C28.971,15 33,19.029 33,24 C33,28.971 28.971,33 24,33 L24,33 Z"></path>
        </svg>
      </div>`,
        popupAnchor: [-0, -0],
        iconAnchor: [12.5, 41],
        iconSize: [25, 41],
      }),
      position: {
        lat: marker.latitude,
        lng: marker.longitude,
        onmouseover: (e) => e.target.openPopup(),
        onmouseout: (e) => e.target.closePopup(),
      },
      draggable,
    }}
  >
    {withPopup && (
      <Popup className="request-popup">
        <span>{marker.description}</span>
      </Popup>
    )}
  </Marker>
);
